module.exports = __webpack_public_path__ + "img/thumbnail_Coyote_j_normal.f814bf40.png";